import Router from "vue-router";
import store from "../vuex/store";
import { ErrorReportingOpts } from "@/model/component.model";

// eslint-disable-next-line no-undef
declare const ineum;
const instana = ineum;

function escapeRegExp(text: string) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export default function configureInstana(router: Router) {
  if (isInstanaEnabled()) {
    instana("reportingUrl", "https://eum-blue-saas.instana.io");

    let instanaKey = "b9_GFaBpQjWzRZtBui8VMA";
    if (store.getters.envs.isIntegration) {
      instanaKey = "evWN7rN-TcGTh_tnEOBp-A";
    }
    if (store.getters.envs.isPreProduction) {
      instanaKey = "A4_zT23ZTqW4-M5OrrlaEg";
    }
    if (store.getters.envs.isProduction) {
      instanaKey = "3F5jJXwuQqSN2ebznjLlaw";
    }
    instana("key", instanaKey);
    instana("trackSessions");

    //ignored messages ( regex )
    instana("ignoreErrorMessages", [
      /LA_OFFLINE/i,
      /LA_NOVERSION/i,
      /MANAGED_SHIPMENT_NOT_FOUND/i,
      /ResizeObserver loop limit exceeded/i
    ]);

    instana("meta", "version", process.env.VUE_APP_VERSION);

    router.afterEach(to => {
      let pageName = to.path;
      if (to.matched && to.matched.length > 0) {
        pageName = to.matched[to.matched.length - 1].path;
      }
      instana("page", pageName);
    });
    instana("allowedOrigins", [
      new RegExp(escapeRegExp(store.getters.BASE_API_URL))
    ]);
  }
  trackLanguage();
  trackUserLogged();
  updateStoreSelected();
  updateMultiStoreSelected();
  store.watch(
    state => state.appVersion,
    (newValue: any, oldValue: any) => {
      instana("meta", "version", store.state.appVersion);
    },
    {}
  );
  store.watch(
    state => state.language,
    (newValue: any, oldValue: any) => {
      trackLanguage();
    },
    {}
  );
  store.watch(
    state => state.user,
    (newValue: any, oldValue: any) => {
      trackUserLogged();
    },
    { deep: true }
  );
  store.watch(
    state => state["customer"].storeInfo.store,
    (newValue: any, oldValue: any) => {
      updateStoreSelected();
    },
    { deep: true }
  );
  store.watch(
    state => state["customer"].storeInfo.store.multiStore,
    (newValue: any, oldValue: any) => {
      updateMultiStoreSelected();
    },
    { deep: true }
  );
}

export function reportError(error: Error | string, opts?: ErrorReportingOpts) {
  if (isInstanaEnabled()) {
    instana("reportError", error, opts);
  }
}

/**
 * true if instana loaded
 */
function isInstanaEnabled() {
  return ineum;
}

function trackUserLogged() {
  if (isInstanaEnabled()) {
    if (store.state.user && store.state.user.id) {
      const userId = store.state.user.id || null;
      const userName = store.state.user.username || null;
      instana("user", userId, userName, null);
    } else {
      instana("user", null, "anonymous", null);
    }
  }
}

function trackLanguage() {
  if (isInstanaEnabled()) {
    instana("meta", "language", store.state.language);
  }
}

function updateStoreSelected() {
  if (isInstanaEnabled()) {
    if (
      store.state["customer"].storeInfo.store &&
      store.state["customer"].storeInfo.store.storeCode
    ) {
      instana(
        "meta",
        "store",
        store.state["customer"].storeInfo.store.storeCode
      );
    } else {
      instana("meta", "store", "");
    }
  }
}

function updateMultiStoreSelected() {
  if (isInstanaEnabled()) {
    if (
      store.state["customer"].storeInfo.store &&
      store.state["customer"].storeInfo.store.multiStore
    ) {
      instana(
        "meta",
        "multistore",
        store.state["customer"].storeInfo.store.multiStore.businessName
      );
    } else {
      instana("meta", "multistore", "");
    }
  }
}
